module.exports = __webpack_public_path__ + "static/assets/929ea5b8361c6136b6db2a8b9d05e804.svg";